import React, { useState } from 'react';
import { FiUsers, FiPlus, FiEdit2, FiTrash2 } from 'react-icons/fi';

const SavedTravelers: React.FC = () => {
    // Mock data since we disconnected supabase. 
    // In a real app, this would fetch via apiFetch('/travelers')
    const [travelers, setTravelers] = useState([
        { id: 1, firstName: 'Chukwudi', lastName: 'Okafor', type: 'Adult', dob: '1990-05-14', passportNumber: 'A00123456' },
        { id: 2, firstName: 'Ngozi', lastName: 'Okafor', type: 'Child', dob: '2015-08-22', passportNumber: 'A00987654' }
    ]);
    const [isAdding, setIsAdding] = useState(false);

    return (
        <div className="max-w-5xl mx-auto py-12 px-4 sm:px-6 lg:px-8 animate-fade-in-up">
            <div className="flex justify-between items-end mb-10">
                <div>
                    <h1 className="text-3xl font-extrabold text-slate-900 flex items-center">
                        <FiUsers className="mr-3 text-indigo-600" /> Saved Travelers
                    </h1>
                    <p className="text-slate-500 mt-2 font-medium">Manage details for your family or frequent travel companions to book faster.</p>
                </div>
                <button 
                    onClick={() => setIsAdding(!isAdding)}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-full font-semibold shadow-lg shadow-indigo-200 transition-all flex items-center"
                >
                    <FiPlus className="mr-2" /> Add Traveler
                </button>
            </div>

            {isAdding && (
                <div className="glass rounded-3xl p-8 mb-8 border border-indigo-100">
                    <h2 className="text-xl font-bold text-slate-900 mb-6">Add New Traveler</h2>
                    <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-slate-700">First Name</label>
                            <input type="text" className="mt-1 block w-full border border-slate-300 rounded-lg shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white/50" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700">Last Name</label>
                            <input type="text" className="mt-1 block w-full border border-slate-300 rounded-lg shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white/50" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700">Date of Birth</label>
                            <input type="date" className="mt-1 block w-full border border-slate-300 rounded-lg shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white/50" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700">Passport Number</label>
                            <input type="text" className="mt-1 block w-full border border-slate-300 rounded-lg shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white/50" />
                        </div>
                        <div className="md:col-span-2 flex justify-end space-x-3 mt-4">
                            <button type="button" onClick={() => setIsAdding(false)} className="px-5 py-2 border border-slate-300 rounded-lg text-slate-700 font-medium hover:bg-slate-50 transition-colors">Cancel</button>
                            <button type="button" className="px-5 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors shadow-md shadow-indigo-200">Save Traveler</button>
                        </div>
                    </form>
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {travelers.map(traveler => (
                    <div key={traveler.id} className="glass rounded-2xl p-6 relative group border border-transparent hover:border-indigo-100 transition-all duration-300">
                        <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity flex space-x-2">
                            <button className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-full transition-colors"><FiEdit2 size={18} /></button>
                            <button className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors"><FiTrash2 size={18} /></button>
                        </div>
                        <div className="flex items-center mb-4">
                            <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-100 to-blue-50 text-indigo-600 flex items-center justify-center font-bold text-lg mr-4">
                                {traveler.firstName[0]}{traveler.lastName[0]}
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-slate-900">{traveler.firstName} {traveler.lastName}</h3>
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800">
                                    {traveler.type}
                                </span>
                            </div>
                        </div>
                        <div className="space-y-2 mt-4 text-sm text-slate-600">
                            <div className="flex justify-between">
                                <span className="font-medium">Date of Birth:</span>
                                <span>{traveler.dob}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-medium">Passport:</span>
                                <span>{traveler.passportNumber}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SavedTravelers;
